import axios from "../axiosInstance";

export const getStates = (countryId) =>
  axios.get(`/location/states?countryId=${countryId}`);

export const getCities = (stateId) =>
  axios.get(`/location/cities?stateId=${stateId}`);

export const getAreas = (cityId) =>
  axios.get(`/location/areas?cityId=${cityId}`);
